import React, { useContext } from "react";
import "./Calendar.css";
import { Tooltip } from "primereact/tooltip";
import React from "react";
import { useMutateGtfsResource } from "../Queries";
import { useState, useRef } from "react";
import { gtfsFormatDateToYYYYMMDD } from "../helpers/gtfsDateUtils";
import { ContextMenu } from "primereact/contextmenu";
import { ToolsContext } from "../ToolsContext";


const daysOfWeek = ["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"];

export const GTFSCalendar = ({ year, getDayClass }) => {
  const modifyCalendar = useMutateGtfsResource();
  const tool = useContext(ToolsContext);
  const [selectedDay,setSelectedDay] = useState();
  const cm = useRef(null);

  function handleInputDone(propertyName,value) {
    const payload = {
      query: {
        modified_id: tool.propertyEditor.service_id,
        resourceTable: 'calendars'
      },
      fields: {}
    };
    payload.fields[propertyName] = value;
    const mutation = modifyCalendar.mutate(payload);
  }

  const cmItems = [
    {
      label: 'Ustaw wyjątek: w ten dzień kursuje',
      icon: 'fa-solid fa-calendar-plus',
      command: () => {
        handleInputDone('exceptions_date_added_add',[selectedDay]);
      }
    },
    {
      label: 'Ustaw wyjątek: w ten dzień nie kursuje',
      icon: 'fa-solid fa-calendar-minus',
      command: () => {
        handleInputDone('exceptions_date_removed_add',[selectedDay]);
      }
    },
    {
      label: 'Usuń ten dzień z listy wyjątków',
      command: () => {
        handleInputDone('exceptions_date_added_remove',[selectedDay]);
        handleInputDone('exceptions_date_removed_remove',[selectedDay]);
      }
    },
  ]

  const onRightClick = (event, day) => {
    if (cm.current) {
        setSelectedDay(day);
        cm.current.show(event);
    }
  };


  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (month, year) => {
    let firstDay = new Date(year, month, 1).getDay();
    return firstDay === 0 ? 6 : firstDay - 1;
  };

  return (
    <div key={year} className="calendar-container">
      {[...Array(12)].map((_, month) => {
        const daysInMonth = getDaysInMonth(month, year);
        const firstDay = getFirstDayOfMonth(month, year);
        const days = Array.from({ length: firstDay }, () => null).concat(
          [...Array(daysInMonth)].map((_, i) => i + 1)
        );

        return (
          <div key={month} className="month-container">
            <Tooltip target=".out-of-range" content="Data poza okresem ważności" />
            <Tooltip target=".normally-runs" content="Kursuje normalnie" />
            <Tooltip target=".normally-does-not-run" content="Nie kursuje" />
            <Tooltip target=".runs-as-exception" content="Wyjątkowo kursuje" />
            <Tooltip target=".does-not-run-as-exception" content="Wyjątkowo nie kursuje" />
            <h2 className="month-title">
              {new Date(year, month).toLocaleString("pl-PL", { month: "long" })}
            </h2>
            <div className="days-grid">
              {daysOfWeek.map((day) => (
                <div key={day} className="day-header">
                  {day}
                </div>
              ))}
              {days.map((day, index) => (
                <div
                  key={index}
                  className={`day-cell ${day ? getDayClass(year, month, day) : ""}`}
                  onContextMenu={(event) => onRightClick(event, gtfsFormatDateToYYYYMMDD(new Date(year, month, day)))}
                >
                  {day || ""}
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <ContextMenu ref={cm} model={cmItems} onHide={() => setSelectedDay(undefined)} />
    </div>
  );
};